import React from 'react';

import DefaultLogin from 'scenes/Login/DefaultLogin';
import OhlaLogin from 'scenes/Login/OhlaLogin';

import { OHLA_DOMAIN, OHLA_DOMAIN_V2, TEST_DOMAIN } from '../../config/Config';

import './Login.scss';

function Login() {
  const currentDomain = window.location.hostname;
  console.log('Current domain', currentDomain);

  if (
    currentDomain === OHLA_DOMAIN ||
    currentDomain === TEST_DOMAIN ||
    currentDomain === OHLA_DOMAIN_V2
  ) {
    return <OhlaLogin />;
  }

  return <DefaultLogin />;
}

export default Login;
